import styled from 'styled-components';

import { themeGet } from 'ravenjs/utils/theme';

const DataListStyled = styled.div`
    padding: 0 20px;
    /**
     * Add all of the remaining styles from theme
     */
    ${themeGet('DataList.styles')};
`;

export default DataListStyled;
